import "./App.css";

import { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import MainPage from "./pages/MainPage";
import Header from "./components/Header";
import Footer from "./components/Footer";
import AboutUspage from "./pages/AboutUsPage";

import { io } from "socket.io-client";
import Allprices from "./pages/AllPrices";

const App = () => {
  const { REACT_APP_URL } = process.env;
  // states
  const [configs, setConfigs] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [coins, setCoins] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const socket = io(`${REACT_APP_URL}`, {
      transports: ["polling"],
    });

    socket.on("getCurrencies", async (data) => {
      setCurrencies(data);
    });
    socket.on("getCoins", (data) => {
      setCoins(data);
    });

    const getCurrencies = async () => {
      try {
        const currRes = await fetch(`${REACT_APP_URL}/api/getallcurrencies`, {
          method: "POST",
        });
        const currData = await currRes?.json();
        setCurrencies(currData);

        const coinRes = await fetch(`${REACT_APP_URL}/api/getallcoins`, {
          method: "POST",
        });
        const coinData = await coinRes?.json();
        setCoins(coinData);
        
        if (
          coinData &&
          currData &&
          coinData.length !== 0 &&
          currData.length !== 0
        ) {
          setLoading(false);
        }
      } catch (err) {
        console.log(err);
      }
    };
    getCurrencies();

    const getConfigs = async () => {
      try {
        const res = await fetch(`${REACT_APP_URL}/api/getConfig`);
        const data = await res.json();
        setConfigs(data);
      } catch (err) {
        console.log(err);
      }
    };
    getConfigs();
  }, []);

  return (
    <div className="app-container">
      <Header configs={configs} />
      <Routes>
        <Route
          exact
          path="/"
          element={
            <MainPage
              currencies={currencies}
              coins={coins}
              isLoading={loading}
            />
          }
        />
        <Route
          path="/all-prices"
          element={<Allprices currencies={currencies} isLoading={loading} />}
        />
        <Route path="/about-us" element={<AboutUspage configs={configs} />} />
      </Routes>
      <Footer configs={configs} />
    </div>
  );
};

export default App;
